import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import WhitelabelBootstrap from "components/shared/WhitelabelBootstrap";
import ErrorBoundary from "components/shared/ErrorBoundary";
import history from "./history";
import "./locales";
import appConfig from "configs/app.config";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: appConfig.gtmCode,
};
TagManager.initialize(tagManagerArgs);

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter history={history}>
            <WhitelabelBootstrap>
              <Theme>
                <Layout />
              </Theme>
            </WhitelabelBootstrap>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
}
export default App;
